@reference "@glow/tailwind-config/reference.css";

.container {
  @apply basis-0;
  @apply grow;
}

.container input {
  @apply absolute;
  @apply opacity-0;
  @apply h-0;
  @apply w-0;
}

.button {
  @apply cursor-pointer;
  @apply border-solid;
  @apply border;
  @apply border-gray-300;
  @apply font-semibold;
  @apply text-primary-600;
  @apply rounded-sm;
  @apply flex;
  @apply flex-col;
  @apply items-center;
  @apply p-6;
  @apply text-center;
}

.container input ~ *:hover,
.container input:focus-visible ~ *,
.container input:focus ~ *:hover {
  @apply bg-gray-200;
  box-shadow: 5px 5px 0px 0px rgba(0, 0, 0, 0.45);
}

.container input:checked ~ .button {
  @apply bg-primary-600;
  @apply border-primary-600;
  @apply text-white;
}

.container input:checked ~ *:hover,
.container input:checked:focus-visible ~ *,
.container input:checked:focus ~ *:hover {
  @apply bg-primary-900;
  @apply border-primary-900;
  box-shadow: 5px 5px 0px 0px rgba(0, 0, 0, 0.45);
}

.icon {
  @apply text-4xl;
  @apply flex;
  @apply mb-2;
}

.text {
  @apply text-sm;
}
